document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname !== '/pages/contact') return;

  // This enhancement targets the "Kontaktformulär" section (contact-form.liquid),
  // which renders in the booking ("vi-book") visual style. All lookups are scoped
  // to that specific form so other vi-book forms on the page (e.g. boka demo) are
  // left untouched. If the section is not present/enabled, we bail out quietly.
  var form = document.getElementById('ContactForm');
  if (!form) return;
  var scope = form.closest('.vi-book') || form.closest('.shopify-section') || document;

  function getQueryParam(param) {
    return new URLSearchParams(window.location.search).get(param);
  }

  function esc(str) {
    return String(str || '').replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[c];
    });
  }

  // --- Request-mode handling ---
  var REQUEST_MODES = {
    reklamation: {
      heading: 'Reklamation',
      intro: 'Välj order eller ange ordernummer och beskriv vad som hänt. Vi återkommer för att lösa detta så snart vi kan.',
      subject: 'Reklamation',
      bodyPlaceholder: 'Beskriv problemet, berörd produkt och önskad åtgärd.',
      bodyLabel: 'Beskrivning'
    },
    produktforfragan: {
      heading: 'Produktförfrågan',
      intro: 'Letar du efter en producent, stil, region, årgång eller produkt vi inte har listad? Skicka en förfrågan så hjälper vi dig.',
      subject: 'Produktförfrågan',
      bodyPlaceholder: 'Övriga kommentarer eller detaljer om produkten du söker.',
      bodyLabel: 'Kommentar'
    },
    adressandring: {
      heading: 'Adressändring',
      intro: 'Meddela oss vilken adress som ska uppdateras, så hjälper vi dig.',
      subject: 'Adressändring',
      bodyPlaceholder: 'Typ av ändring:\nFöretag:\nKontaktperson:\nTelefon:\nNuvarande adress:\nNy adress:\nKommentar:',
      bodyLabel: 'Adressuppgifter'
    }
  };

  var ALLOWED_REQUESTS = Object.keys(REQUEST_MODES);
  var requestParam = getQueryParam('request');
  var mode = (requestParam && ALLOWED_REQUESTS.indexOf(requestParam) !== -1)
    ? REQUEST_MODES[requestParam]
    : null;

  if (!mode) {
    // Handle legacy product param
    var product = getQueryParam('product');
    if (product) {
      var placeholder = document.getElementById('product-title-placeholder');
      if (placeholder) {
        placeholder.innerHTML = '<h3>Du hör av dig angående: ' + esc(product) + '</h3>';
      }
      var textarea = form.querySelector('textarea');
      if (textarea) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          textarea.value = 'Angående: ' + product + '\n\n' + textarea.value;
          form.submit();
        });
      }
    }
    return;
  }

  // Apply heading
  var headingEl = scope.querySelector('.vi-book__heading');
  if (headingEl) headingEl.textContent = mode.heading;

  // Apply intro
  var introEl = scope.querySelector('.vi-book__subtitle');
  if (introEl) introEl.innerHTML = '<p>' + esc(mode.intro) + '</p>';

  // Apply subject
  var subjectEl = form.querySelector('input[name="contact[subject]"]');
  if (subjectEl) subjectEl.value = mode.subject;

  // Apply body placeholder + label
  var bodyEl = form.querySelector('.vi-book__textarea') || form.querySelector('textarea');
  if (bodyEl) {
    bodyEl.setAttribute('placeholder', mode.bodyPlaceholder);
    var bodyFieldEl = bodyEl.closest('.vi-book__field');
    var bodyLabel = bodyFieldEl && bodyFieldEl.querySelector('.vi-book__label');
    if (bodyLabel) bodyLabel.textContent = mode.bodyLabel;
  }

  // Update page title
  document.title = mode.heading + ' – ' + document.title.split(' – ').slice(-1)[0];

  // Hide department checkboxes — not relevant for dedicated modes
  var deptBlock = scope.querySelector('[data-contact-departments]');
  if (deptBlock) deptBlock.style.display = 'none';

  var fieldsEl = form.querySelector('.vi-book__fields');
  if (!fieldsEl) return;

  // Build a booking-style field block (label above the control).
  function fieldBlock(inner) {
    return '<div class="vi-book__field vi-book__field--full">' + inner + '</div>';
  }
  function labelFor(id, text) {
    return '<label class="vi-book__label" for="' + id + '">' + esc(text) + '</label>';
  }
  function selectControl(id, name, ariaLabel, optionsHtml) {
    return '<select class="vi-book__select" id="' + id + '" name="' + esc(name) + '" aria-label="' + esc(ariaLabel) + '">' + optionsHtml + '</select>';
  }

  // ── REKLAMATION: inject order selection ───────────────────────────────────
  if (requestParam === 'reklamation') {
    var orders = (typeof window.VI_CUSTOMER_ORDERS !== 'undefined') ? window.VI_CUSTOMER_ORDERS : [];
    var orderFieldHtml = '';

    if (orders.length > 0) {
      var optionsHtml = '<option value="">– Välj order –</option>'
        + orders.map(function(o) {
          return '<option value="' + esc(o.name) + '">' + esc(o.name) + ' (' + esc(o.date) + ')</option>';
        }).join('');
      orderFieldHtml = fieldBlock(
        labelFor('ContactForm-order', 'Välj order (valfritt)')
        + selectControl('ContactForm-order', 'contact[Order]', 'Välj order', optionsHtml)
      );
    } else {
      orderFieldHtml = fieldBlock(
        labelFor('ContactForm-order', 'Ordernummer')
        + '<input class="vi-book__input" type="text" id="ContactForm-order" name="contact[Ordernummer]" placeholder="t.ex. #1001" autocomplete="off">'
      );
    }

    var problemFieldHtml = fieldBlock(
      labelFor('ContactForm-problem', 'Problemtyp')
      + selectControl('ContactForm-problem', 'contact[Problemtyp]', 'Problemtyp',
          '<option value="">– Problemtyp –</option>'
          + '<option value="Trasig förpackning">Trasig förpackning</option>'
          + '<option value="Fel produkt levererad">Fel produkt levererad</option>'
          + '<option value="Saknad leverans">Saknad leverans</option>'
          + '<option value="Kvalitetsavvikelse">Kvalitetsavvikelse</option>'
          + '<option value="Korkat/defekt">Korkat/defekt</option>'
          + '<option value="Fel antal">Fel antal</option>'
          + '<option value="Annat">Annat</option>')
    );

    var atgardFieldHtml = fieldBlock(
      labelFor('ContactForm-atgard', 'Önskad åtgärd')
      + selectControl('ContactForm-atgard', 'contact[Önskad åtgärd]', 'Önskad åtgärd',
          '<option value="">– Önskad åtgärd –</option>'
          + '<option value="Ersättning/omleverans">Ersättning / omleverans</option>'
          + '<option value="Kreditering">Kreditering</option>'
          + '<option value="Utredning">Utredning</option>'
          + '<option value="Annat">Annat</option>')
    );

    var wrapper = document.createElement('div');
    wrapper.innerHTML = orderFieldHtml + problemFieldHtml + atgardFieldHtml;
    // Insert before the textarea field
    var bodyField = bodyEl && bodyEl.closest('.vi-book__field');
    if (bodyField) {
      Array.from(wrapper.children).forEach(function(child) {
        fieldsEl.insertBefore(child, bodyField);
      });
    } else {
      fieldsEl.prepend(wrapper);
    }
  }

  // ── PRODUKTFÖRFRÅGAN: inject structured product request fields ──────────
  if (requestParam === 'produktforfragan') {
    var pf = [
      { id: 'pf-vad', name: 'contact[Vad söker du]', label: 'Vad söker du?', placeholder: 'Produktnamn, producent eller beskrivning' },
      { id: 'pf-producent', name: 'contact[Producent]', label: 'Producent (om känt)', placeholder: 't.ex. Domaine Leflaive' },
      { id: 'pf-land', name: 'contact[Land/region]', label: 'Land / region', placeholder: 't.ex. Frankrike, Bourgogne' },
      { id: 'pf-stil', name: 'contact[Stil/vintyp]', label: 'Stil / vintyp', placeholder: 't.ex. Chardonnay, naturvin, pet nat' },
      { id: 'pf-argvarg', name: 'contact[Årgång]', label: 'Årgång', placeholder: 't.ex. 2019' },
      { id: 'pf-volym', name: 'contact[Volym/antal]', label: 'Volym / antal', placeholder: 't.ex. 6 fl à 75 cl' },
      { id: 'pf-pris', name: 'contact[Prisnivå]', label: 'Prisnivå per flaska', placeholder: 't.ex. 150–350 kr' }
    ];
    var pfHtml = pf.map(function(f) {
      return fieldBlock(
        labelFor(f.id, f.label)
        + '<input class="vi-book__input" type="text" id="' + f.id + '" name="' + esc(f.name) + '" placeholder="' + esc(f.placeholder) + '">'
      );
    }).join('');
    var pfWrapper = document.createElement('div');
    pfWrapper.innerHTML = pfHtml;
    var bodyFieldPf = bodyEl && bodyEl.closest('.vi-book__field');
    if (bodyFieldPf) {
      Array.from(pfWrapper.children).forEach(function(child) {
        fieldsEl.insertBefore(child, bodyFieldPf);
      });
    } else {
      fieldsEl.appendChild(pfWrapper);
    }
  }
});
